package one.healthium.profile.ui.avatar

import one.healthium.domain.user.UserModel

internal data class UserAvatarUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
) {
    val userAvatarUrl: String? = userModel?.profile?.avatarUrl
}
